'use es6';

export const OK = 200;
export const NOT_MODIFIED = 304;
export const BAD_REQUEST = 400;
export const NOT_FOUND = 404;
export const CONFLICT = 409;